<template>
    <button :class="`button button__${type}${className !== '' ? ` ${className}` : ''} ${isNoHover ? `no-hover` : ``}`" @click="onChangeButton()" :disabled="isLoading || isDisable">
        {{ getTranslatedText(text) }}
        <Loading v-if="isLoading" :isLoadingPage="false" />
    </button>
</template>
<script>
import Loading from '@/components/common/loading'
import languageMixins from '@/mixins/language/language-mixins'

export default {
    mixins: [languageMixins],
    components: { Loading },
    props: {
        type: {
            type: String,
            default: 'default',
        },
        className: {
            type: String,
            default: '',
        },
        text: {
            type: String,
            default: '',
        },
        isNoHover: {
            type: Boolean,
            default: false,
        },
        isLoading: {
            type: Boolean,
            default: false,
        },
        isDisable: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {}
    },
    methods: {
        onChangeButton() {
            this.$emit('action-button')
        },
    },
}
</script>

<style lang="scss">
@import '~ThemePath/scss/common/_button.scss';
</style>
